import { Button, Modal } from "@mantine/core";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";
import type { Site } from "../../../utils/backend-types";
import { LoadOrError } from "../../LoadOrError/LoadOrError";
import { useMetersBySiteIds } from "../hooks/useMetersBySiteIds";
import { ImportLogs } from "./ImportLogs/ImportLogs";

interface ImportLogsModalProps {
  isOpen: boolean;
  configurationId: number;
  sites: Array<Site>;
  onToggle: () => void;
}

function ImportLogsModal({
  isOpen,
  configurationId,
  sites,
  onToggle
}: ImportLogsModalProps) {
  const { isMetersQueryLoading, metersBySiteId, metersQueryError } =
    useMetersBySiteIds(sites);

  const meterNamesByMeterId = metersBySiteId?.reduce<Record<number, string>>(
    (names, meter) => {
      names[meter.id] = meter.name;
      return names;
    },
    {}
  );

  return (
    <Modal
      className="ImportLogsModal"
      opened={isOpen}
      size="min(80vw, 1200px)"
      title="Historie"
      onClose={onToggle}
    >
      <LoadOrError error={metersQueryError} loading={isMetersQueryLoading}>
        {meterNamesByMeterId && (
          <ImportLogs
            configurationId={configurationId}
            meterNames={meterNamesByMeterId}
          />
        )}
      </LoadOrError>
      <ModalFooter>
        <Button variant="default" onClick={onToggle}>
          Schließen
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { ImportLogsModal };
